import React, {FC} from 'react';
import Typography from '@material-ui/core/Typography';
import {Box as MUIBox} from '@material-ui/core';
import {Label} from '../Label/Label';
import {BoxContent} from './components';
interface IBoxProps {
  label?: string;
  content: string;
  withLink?: boolean;
  withButtonLink?: boolean;
  className?: string;
  avatarUrl?: string;
  userInitials?: string;
  size?: 'small' | 'large';
  linkCallback?: () => void;
}

export const Box: FC<IBoxProps> = ({
  label,
  content,
  withLink = false,
  withButtonLink = false,
  linkCallback,
  className,
  avatarUrl,
  userInitials,
  size,
}) => {
  return (
    <Typography component="div">
      {label ? <Label label={label} withLeftMargin={false} withFontBold withMarginBottom={false} /> : null}
      {content && (
        <MUIBox color="#171A1D" className={className}>
          <BoxContent
            size={size}
            avatarUrl={avatarUrl}
            userInitials={userInitials}
            content={content}
            withLink={withLink}
            withButtonLink={withButtonLink}
            linkCallback={linkCallback}
          />
        </MUIBox>
      )}
    </Typography>
  );
};
